import { animate, style, transition, trigger } from '@angular/animations'

export const fadeOut = trigger('FadeOut', [
	transition(':leave', [
		style({ opacity: 1 }),
		animate('240ms ease-out', style({ opacity: 0 })),
	]),
])

export const softRise = trigger('SoftRise', [
	transition(':enter', [
		style({ opacity: 0, transform: 'translateY(8px)' }),
		animate(
			'280ms cubic-bezier(0.16, 1, 0.3, 1)',
			style({ opacity: 1, transform: 'translateY(0)' })
		),
	]),
])

export const fadeInOut = trigger('FadeInOut', [
	transition(':enter', [
		style({
			transform: 'scale(0.99)',
			opacity: 0,
		}),
		animate(
			'160ms ease-out',
			style({
				transform: 'scale(1)',
				opacity: 1,
			})
		),
	]),
	transition(':leave', [
		style({
			transform: 'scale(1)',
			opacity: 1,
		}),
		animate(
			'160ms ease-out',
			style({
				transform: 'scale(0.99)',
				opacity: 0,
			})
		),
	]),
])
